module.exports = __webpack_public_path__ + "img/chapter__8_image_4.7c5000f7.png";